export function initProductVariants() {
    const allParameters = document.querySelectorAll('select.hidden-split-parameter, .surcharge-parameter')
    allParameters.forEach((parameter) => {
        addSelectButtons(`.parameter-id-${parameter.getAttribute('data-parameter-id')}`)
    })
    let isFirstChange = true
    document.addEventListener('ShoptetSplitVariantParameterChange', () => {
        setTimeout(() => {
            makeUnavailable()
            makeUnavailableSingle()
            if (!isFirstChange) {
                slideToVariantImage()
            } else {
                isFirstChange = false
            }
        }, 150)
    })
    handleParamClick()
    makeUnavailableSingle()
    const resetButton = document.getElementById('jsSplitVariantsReset')
    if (resetButton) {
        resetButton.addEventListener('click', () => {
            const allOptions = document.querySelectorAll('.select-option')
            setTimeout(() => {
                allOptions.forEach((option) => {
                    option.classList.remove('active', 'unavailable-option')
                })
            }, 300)
        })
    }
    function makeUnavailableSingle() {
        if (allParameters.length > 1) return
        const availableVariants = shoptet.variantsSplit.necessaryVariantData
        const allVariants = document.querySelectorAll('.select-option')
        if (allVariants) {
            allVariants.forEach((variant) => {
                const fullId = variant.getAttribute('data-full-id')
                const variantData = availableVariants[fullId]
                if (variantData && !variantData.isNotSoldOut) {
                    variant.classList.add('unavailable-option')
                } else {
                    variant.classList.remove('unavailable-option')
                }
            })
        }
    }
    function slideToVariantImage() {
        const swiperGallery = document.querySelector('.swiper-product-gallery')
        const pImage = document.querySelector('.p-image .p-main-image img')?.getAttribute('src')
        if (!swiperGallery || !pImage) return
        const swiperInstance = swiperGallery.swiper
        swiperInstance.slideTo(
            swiperInstance.slides.findIndex((slide) => slide.getAttribute('data-src') === pImage),
            0,
            false
        )
    }
    function makeUnavailable() {
        const unavailableOptions = getUnavailableOptions()
        const customVariantBtns = document.querySelectorAll('.select-option')
        customVariantBtns.forEach((btn) => {
            const btnValue = btn.getAttribute('data-option-value')
            const isUnavailable = unavailableOptions.includes(btnValue)
            if (isUnavailable) {
                btn.classList.add('unavailable-option')
            } else if (!isUnavailable && btn.classList.contains('unavailable-option')) {
                btn.classList.remove('unavailable-option')
            }
        })
    }
    function getUnavailableOptions() {
        const allParameterElements = document.querySelectorAll('.hidden-split-parameter')
        const allParameters = Array.from(allParameterElements).filter(
            (param) => !param.querySelector('.advanced-parameter')
        )
        let unavailableOptionsArr = []
        allParameters.forEach((parameter) => {
            const paramId = `#${parameter.getAttribute('id')}`
            const paramElem = document.querySelector(paramId)
            const unavailableGroup = shoptet.variantsUnavailable.getUnavailableOptgroup(paramElem)
            const unavailableOptions = unavailableGroup.querySelectorAll('option')
            if (unavailableOptions) {
                unavailableOptions.forEach((option) => {
                    const value = option.value
                    unavailableOptionsArr.push(value)
                })
            }
        })
        return unavailableOptionsArr
    }
    function handleParamClick() {
        setTimeout(() => {
            const options = document.querySelectorAll('.select-option')
            options.forEach((option) => {
                option.addEventListener('click', () => {
                    const id = option.getAttribute('data-param-id')
                    selectButtonClickAction(option, id)
                })
            })
        }, 50)
    }
    function getButtonsFromSelect(selectIDorClass) {
        const select = document.querySelector(selectIDorClass)
        const idNumber = getNumber(selectIDorClass)
        let buttons = []
        if (select) {
            const options = select.querySelectorAll('option')
            if (options) {
                options.forEach((option) => {
                    let optionValue = option.value
                    let optionClass = option.getAttribute('class') ?? ''
                    let optionTitle = option.innerText
                    if (optionValue === '') {
                        optionClass += ' hide'
                    }
                    if (optionValue === select.value) {
                        optionClass += ' active'
                    }
                    // Add tooltip classes for parameter-id-28
                    if (selectIDorClass === '.parameter-id-28') {
                        optionClass += ' show-tooltip'
                    }
                    buttons.push(
                        `<div data-param-id=${selectIDorClass} ${
                            selectIDorClass === '.parameter-id-28'
                                ? `data-original-title="${optionTitle}"`
                                : ''
                        } class="select-option ${optionClass}" data-full-id="${idNumber}-${optionValue.trim()}" data-option-value="${optionValue.trim()}">${optionTitle}</div>`
                    )
                })
            }
        }
        return buttons
    }
    function getNumber(num) {
        return num.replace(/^\D+/g, '')
    }
    function addSelectButtons(selectIDorClass) {
        const identifier = selectIDorClass
        if (identifier !== '') {
            const identifierElement = document.querySelector(identifier)
            if (identifierElement && !identifierElement.classList.contains('hide')) {
                identifierElement.classList.add('hide')
            }
            const identifierParent = identifierElement ? identifierElement.parentElement : null
            const buttons = getButtonsFromSelect(identifier)
            if (identifierParent && buttons) {
                const variantList = identifierParent.closest('.variant-list, .surcharge-list')
                if (variantList) {
                    const buttonsContent = variantList.querySelector('.selectButtonsContent')
                    if (buttonsContent) {
                        buttonsContent.remove()
                    }
                    const newButtonsContent = document.createElement('div')
                    newButtonsContent.classList.add('selectButtonsContent')
                    identifierParent.append(newButtonsContent)
                    buttons.forEach((button) => {
                        newButtonsContent.innerHTML += button
                    })
                }
            }
        }
    }
    function triggerSelectEvents(element) {
        element.dispatchEvent(new Event('mousedown', { bubbles: true }))
        element.dispatchEvent(new Event('mouseup', { bubbles: true }))
        element.dispatchEvent(new Event('click', { bubbles: true }))
        element.dispatchEvent(new Event('change', { bubbles: true }))
    }
    function selectButtonClickAction(button, joinedSelectOfButtonSelector) {
        const clickedButton = button
        const selectSelector = joinedSelectOfButtonSelector
        // If clicking on already active button
        if (clickedButton.classList.contains('active')) {
            clickedButton.classList.remove('active')
            const select = document.querySelector(selectSelector)
            // Set value to first option (usually empty/default option)
            select.value = select.options[0].value
            triggerSelectEvents(select)
            shoptet.variantsUnavailable.setupAllParameters(getAllParamsSelectIDs())
            return
        }
        // Other buttons
        if (!clickedButton.classList.contains('disabled')) {
            const buttonParentSelect = getParents(clickedButton, '.selectButtonsContent')
            const buttonParentTr = getParents(clickedButton, '.variant-list.variant-not-chosen-anchor ')
            const otherSelectButtons = buttonParentSelect[0].querySelectorAll('.select-option')
            if (otherSelectButtons) {
                otherSelectButtons.forEach((button) => {
                    button.classList.remove('active')
                })
            }
            clickedButton.classList.add('active')
            if (selectSelector !== '' && clickedButton.getAttribute('data-option-value')) {
                const select = document.querySelector(selectSelector)
                select.value = clickedButton.getAttribute('data-option-value')
                // Trigger events
                triggerSelectEvents(select)
                shoptet.variantsUnavailable.setupAllParameters(getAllParamsSelectIDs())
            }
            let options = document.querySelectorAll(
                '.variant-list .advanced-parameter:not(.unavailable-option-wrapper)'
            )
            if (options.length) {
                options[0].click()
            }
        }
    }
    function getAllParamsSelectIDs() {
        const selects = document.querySelectorAll('.variant-list .hidden-split-parameter')
        let ids = []
        if (selects) {
            selects.forEach((select) => {
                ids.push(select.getAttribute('id'))
            })
        }
        return ids
    }
    // function for getting elements parent by selector
    const getParents = function (elem, selector) {
        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function (s) {
                    let matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length
                    while (--i >= 0 && matches.item(i) !== this) {}
                    return i > -1
                }
        }
        // Set up a parent array
        let parents = []
        // Push each parent element to the array
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (selector) {
                if (elem.matches(selector)) {
                    parents.push(elem)
                }
                continue
            }
            parents.push(elem)
        }
        // Return our parent array
        return parents
    }
}